// extracted by mini-css-extract-plugin
export default {"container":"OurBlogs_container__SX0iH","cardcontainer":"OurBlogs_cardcontainer__agk8F","erroralert":"OurBlogs_erroralert__58zBG"};